import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  hospitalId:any;
  hospitalState:any='Active';
  constructor(private apiService: ApiService) {
    this.hospitalId=localStorage.getItem('hospital');
    // console.log('the hospital id is',this.hospitalId)
  }
  getHospitals() {
  
     return this.apiService.get('hospitals/getMyHospitals');
  }
  getRole() {
  
     return this.apiService.get('users/show-profile');
  }
  setDate(date:any){
    // console.log(date);
    if(date)
   { const parts = date.split('-');

    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    
    const formattedDate = `${month}/${day}/${year}`;

return formattedDate;
}
else
return 'N/A'
  }
}
